import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" fill="none" viewBox="0 0 8 14" className={className}>
    <path fill="#000" d="M6.867 13.8L.067 7l6.8-6.8.666.667L1.4 7l6.133 6.133-.666.667z"></path>
  </svg>
);

export default Icon;
